export default "__VITE_ASSET__AUsIaytm__"